import React from "react";
import { useSessionStore } from "../../../stores/UserStore";
import { Box } from "@mantine/core";

const Rectangle = ({ ...props }) => {
  const reseller = useSessionStore((s) => s.reseller);
  return (
    <svg
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.27628 75.6289C-1.42543 69.9272 -1.42542 60.6829 4.27629 54.9812L54.9812 4.27629C60.6829 -1.42542 69.9272 -1.42543 75.6289 4.27628L123.724 52.3711C129.425 58.0728 129.425 67.3171 123.724 73.0188L73.0188 123.724C67.3171 129.425 58.0728 129.425 52.3711 123.724L4.27628 75.6289Z"
        fill={
          reseller?.name !== "Magileads"
            ? "var(--mantine-color-secondary-1)"
            : "#e8dbfe"
        }
      />
    </svg>
  );
};

const Donut = ({ ...props }) => {
  const reseller = useSessionStore((s) => s.reseller);
  return (
    <Box {...props}>
      <svg viewBox="0 0 127 128" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M63.5 128C98.5701 128 127 99.3462 127 64C127 28.6538 98.5701 0 63.5 0C28.4299 0 0 28.6538 0 64C0 99.3462 28.4299 128 63.5 128ZM64.0474 91.5862C78.8615 91.5862 90.8707 79.4825 90.8707 64.5517C90.8707 49.621 78.8615 37.5172 64.0474 37.5172C49.2333 37.5172 37.2241 49.621 37.2241 64.5517C37.2241 79.4825 49.2333 91.5862 64.0474 91.5862Z"
          fill={
            reseller?.name !== "Magileads"
              ? "var(--mantine-color-secondary-1)"
              : "#e8dbfe"
          }
        />
      </svg>
    </Box>
  );
};
const Ellipse = ({ ...props }) => {
  const reseller = useSessionStore((s) => s.reseller);
  return (
    <Box {...props}>
      <svg viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M128 64C128 99.3462 99.3462 128 64 128C28.6538 128 0 99.3462 0 64C0 28.6538 28.6538 0 64 0C99.3462 0 128 28.6538 128 64Z"
          fill={
            reseller?.name !== "Magileads"
              ? "var(--mantine-color-secondary-1)"
              : "#e8dbfe"
          }
        />
      </svg>
    </Box>
  );
};

const LoginDecorations = () => {
  return (
    <>
      <Rectangle
        width={128}
        style={{
          position: "absolute",
          top: -32,
          right: "20%",
        }}
      />

      <Donut
        w={300}
        style={{
          position: "absolute",
          zIndex: 0
        }}
        right={"-16%"}
        bottom={"-20%"}
      />
      <Ellipse
        w={128}
        style={{
          position: "absolute",
          top: "40%",
        }}
        left={{ base: "-16%", lg: "-6%" }}
      />
    </>
  );
};

export default LoginDecorations;
